<template>
	<div class="input-group" v-if="isLoaded" >
		<span class="input-group-prepend">
			<span class="input-group-text">$</span>
		</span>
        <masked-input
            type="text"
            class="form-control text-right"
            v-bind:class="[  true ? inputclass : '' ]"
            v-model="price"
            :mask="numberMask(decimals)"
            :guide="false"
            placeholderChar="#"
            :placeholder="placeholder" >
        </masked-input>
		<!--<input type="text" v-model="valueData" v-bind:class="[  true ? inputclass : '' ]"  @keypress="isPrice($event, decimals)" @paste.prevent  class="form-control" :placeholder="placeholder">-->
	</div>

</template>
<script>

import createNumberMask from 'text-mask-addons/dist/createNumberMask'




export default {
	props: {
        value: {
            type: [String, Number],
        	required : true
        },
		decimals: {
            default: 2
		},
        inputclass :{
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
    },
    components : {
    },
    data() {
		return {
			valueData : '',
			loaded : false
		}
	},
	watch: {
        valueData : function(value) {
            this.$emit('input', value)
        }
    },
	mounted () {
		this.initialize()
    },
    computed: {
    	isLoaded(){
    		return this.loaded
    	},
        price : {
            get: function () {
                return this.valueData + ''
            },
            // setter
            set: function (newValue) {
                this.valueData = newValue
            }
        }
    },
    methods : {
    	initialize : function(){
    		this.valueData = this.value;
    		this.loaded = true;
    	},
        numberMask : function(decimals) {
    	    return createNumberMask({
                prefix: '',
                suffix: '',
                decimalLimit: decimals,
                includeThousandsSeparator : false,
                allowDecimal : true,
            })
		}
    }
}
</script>